import { Typography, Avatar } from '@material-ui/core';
import classes from '../RealPlayViewQualified/ReviewQualifiedRealPlay.module.scss';
import { Skeleton } from '@material-ui/lab';

const LoadingTranscription = () => {
  return (
    <div className={classes.transcriptionContainer}>
      <div className={classes.buttonsContainer}>
        <Skeleton height="10vh" />
        <div className={classes.actions}>
          <Skeleton width="50%" />
          <Skeleton width="50%" />
        </div>
      </div>
      <div className={classes.columnContainer}>
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            className={classes.columnContainer}
            key={`loading-${index}`}
            style={{ marginBottom: '1.1rem', gap: '0.2rem' }}
          >
            <div className={classes.imageContainer}>
              <Skeleton variant="circle">
                <Avatar className={classes.avatar} />
              </Skeleton>

              <Skeleton width="15%">
                <Typography>.</Typography>
              </Skeleton>

              <div className={classes.time}>
                <Skeleton width="100%">
                  <Typography>.</Typography>
                </Skeleton>
              </div>
            </div>
            <div className={classes.rowContainer}>
              <Skeleton width="15%">
                <Typography>.</Typography>
              </Skeleton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingTranscription;
